import clsx from 'clsx';

import {
  FloatingPanel,
  type FloatingPanelProps,
} from '@/shared/ui/FloatingPanel';

export type AttachKind = 'doc' | 'image' | 'video';

const OPTIONS: { kind: AttachKind; label: string; icon: string }[] = [
  {
    kind: 'doc',
    label: 'Документ',
    icon: 'M11 2.6H4.4v10.8h7.2V6.4zM11 2.6v3.8h3.4',
  },
  {
    kind: 'image',
    label: 'Картинка',
    icon: 'M2.6 4h10.8v8H2.6zM2.6 10l3-3 2.6 2.6L10.6 8l2.8 2.8',
  },
  {
    kind: 'video',
    label: 'Видео',
    icon: 'M2.6 4.4h7.4v7.2H2.6zM10 8l3.4-2v6z',
  },
];

export const ACCEPT_BY_KIND: Record<AttachKind, string> = {
  doc: '',
  image: 'image/*',
  video: 'video/*',
};

/** Меню скрепки: Документ / Картинка / Видео (+ Голосовое, если передан onVoice).
 *  Всплывает у якоря — якорь и сторону задаёт родитель. */
export function RAttachMenu({
  onPick,
  onVoice,
  ...placement
}: {
  onPick: (kind: AttachKind) => void;
  onVoice?: () => void;
} & Pick<
  FloatingPanelProps,
  'anchorRef' | 'side' | 'align' | 'sideOffset' | 'topOffset' | 'alignOffset'
>) {
  return (
    <FloatingPanel
      {...placement}
      className={clsx(
        'w-[214px] overflow-hidden rounded-[12px] border border-[rgba(46,62,106,0.12)] bg-white p-[5px]',
        'shadow-[0_16px_36px_rgba(30,42,74,0.2)]'
      )}
      role="menu"
    >
      {OPTIONS.map((o) => (
        <button
          key={o.kind}
          type="button"
          onClick={() => onPick(o.kind)}
          className="flex w-full items-center gap-[10px] rounded-[9px] p-[9px] text-left text-[12px] text-[#575757] hover:bg-[rgba(46,62,106,0.06)]"
          role="menuitem"
        >
          <span className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-[8px] border border-[rgba(59,77,127,0.16)] bg-white">
            <svg
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden
            >
              <path
                d={o.icon}
                stroke="#57B792"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span>{o.label}</span>
        </button>
      ))}

      {onVoice ? (
        <button
          type="button"
          onClick={onVoice}
          className="flex w-full items-center gap-[10px] rounded-[9px] p-[9px] text-left text-[12px] text-[#575757] hover:bg-[rgba(46,62,106,0.06)]"
          role="menuitem"
        >
          <span className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-[8px] border border-[rgba(59,77,127,0.16)] bg-white">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#E59D02"
              strokeWidth={1.8}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M12 3.5a2.6 2.6 0 0 1 2.6 2.6v5.4a2.6 2.6 0 0 1-5.2 0V6.1A2.6 2.6 0 0 1 12 3.5zM5.8 11.2a6.2 6.2 0 0 0 12.4 0M12 17.6V21" />
            </svg>
          </span>
          <span>Голосовое</span>
        </button>
      ) : null}
    </FloatingPanel>
  );
}
